import {
  DirectTelemetry,
  isCriticalTelemetry,
  Telemetry,
  TelemetryWithNotification,
} from "../features/aircraft/types";
import telemetry from "../types/telemProto";

export const parseAvionics = (avionics: string) => {
  const splitAvionics = avionics.split(";");
  const simpleId = splitAvionics[2].split(" ")[1];

  return { simpleId };
};

export const selectFcu = (
  telemetry: telemetry.domain.ITelem & TelemetryWithNotification
) => {
  if (!telemetry) return null;
  const { fcu1, fcu2, fcu3 } = telemetry;
  if (telemetry.fcu_in_control === 1) {
    return fcu1;
  } else if (telemetry.fcu_in_control === 2) {
    return fcu2;
  } else if (telemetry.fcu_in_control === 3) {
    return fcu3;
  }
  return fcu1;
};

export const parseDirectTelemetry = (
  fullTelemetry: DirectTelemetry
): {
  uavId: string;
  flightMode: string;
  uavState: string;
  stale: boolean;
  pos: [number, number];
} | null => {
  if (!fullTelemetry) return null;
  if (isCriticalTelemetry(fullTelemetry.payload)) {
    const telemetryAge = Date.now() - fullTelemetry.timestamp;
    const telemetryIsStale =
      !fullTelemetry.timestamp || telemetryAge > 1000 * 5;
    if (fullTelemetry?.payload?.uav_id && fullTelemetry?.payload?.uav_state) {
      return {
        uavId: fullTelemetry?.payload?.uav_id,
        flightMode: fullTelemetry?.payload?.flight_mode,
        uavState: fullTelemetry?.payload?.uav_state,
        stale: telemetryIsStale,
        pos: [fullTelemetry?.payload?.lat, fullTelemetry?.payload?.lon],
      };
    }
  } else {
    const fcuInControl = selectFcu(fullTelemetry.payload);

    const telemetryAge = Date.now() - fullTelemetry.timestamp;
    const telemetryIsStale =
      !fullTelemetry.timestamp || telemetryAge > 1000 * 5;
    if (
      fcuInControl &&
      fcuInControl.flight_mode &&
      fullTelemetry?.payload?.uav_id &&
      fullTelemetry?.payload?.uav_state &&
      typeof fcuInControl.gps?.lat === "number" &&
      isFinite(fcuInControl.gps?.lat) &&
      typeof fcuInControl.gps?.lon === "number" &&
      isFinite(fcuInControl.gps?.lon)
    ) {
      return {
        uavId: fullTelemetry?.payload?.uav_id,
        flightMode: fcuInControl.flight_mode,
        uavState: fullTelemetry?.payload?.uav_state,
        stale: telemetryIsStale,
        pos: [fcuInControl.gps?.lat, fcuInControl.gps?.lon],
      };
    }
  }
  return null;
};

export const parseTelemetry = (
  fullTelemetry: Telemetry
): {
  uavId: string;
  flightMode: string;
  uavState: string;
  pos: [number, number];
} | null => {
  const telemetry = JSON.parse(
    fullTelemetry.message as any
  ) as telemetry.domain.ITelem & TelemetryWithNotification;
  if (!telemetry) return null;
  const fcuInControl = selectFcu(telemetry);

  if (
    fcuInControl &&
    fcuInControl.flight_mode &&
    fullTelemetry["uav-id"] &&
    telemetry.uav_state &&
    fcuInControl.gps?.lat &&
    fcuInControl.gps?.lon
  ) {
    return {
      uavId: fullTelemetry["uav-id"],
      flightMode: fcuInControl.flight_mode,
      uavState: telemetry.uav_state,
      pos: [fcuInControl.gps?.lat, fcuInControl.gps?.lon],
    };
  }
  return null;
};

export const readableMinsAgo = (timestamp: number) => {
  const now = Date.now();
  const diff = now - timestamp;
  const diffInSecs = diff / 1000;
  const diffInMins = diffInSecs / 60;
  if (diffInSecs < 5) {
    return `now`;
  }
  if (diffInSecs > 60) {
    return `${diffInMins.toFixed(0)} m`;
  } else {
    return `${diffInSecs.toFixed(0)} s`;
  }
};
